export const APPLICATION_MANAGEMENT_GATE = 'application_management'
export const PMU_PORTAL_GATE = 'enable_pmu_portal'
export const PMU_APPLICATION_ACTIONS_GATE = 'pmu_application_actions'
export const ENABLE_GEO_SCRUTINY_ENGINE = 'enable_geo_scrutiny_engine'
export const RELIEVE_AND_DISTRIBUTE_GATE = 'enable_relieve_and_distribute'
export const REPLACE_OFFICER_GATE = 'enable_replace_officer'
export const RETURN_FROM_LEAVE_GATE = 'enable_return_from_leave'
export const NEW_USER_NEW_OFFICER_GATE = 'enable_new_user_new_officer'
export const ENABLE_FEE_ENGINE_LOGS_GATE = 'enable_fee_engine_logs'
export const FILE_TRANSFER_GATE = 'pmu_file_transfer'
export const CAPTCHA_LOGIN_GATE = 'enable_captcha_login'
export const CAPTCHA_APPLICATION_SEARCH_GATE =
   'enable_captcha_application_search'
export const CAPTCHA_TDR_OPEN_SEARCH_GATE = 'enable_captcha_tdr_open_search'
export const CAPTCHA_APPLICATION_ACTION_GATE =
   'enable_captcha_application_action'
export const SHORTFALL_COUNTER_DECREMENT_GATE =
   'pmu_shortfall_counter_decrement'
